
<div class="bg-slate-900 border border-slate-800 rounded-xl p-6 flex flex-col h-full">
    <div class="flex items-center gap-4 mb-4">
        <div [class]="'w-12 h-12 rounded-lg flex items-center justify-center border ' + styles().iconBg + ' ' + styles().iconBorder">
            <i [class]="icon() + ' text-2xl ' + styles().iconText"></i>
        </div>
        <div>
            <h3 class="text-lg font-bold text-white">{{ title() }}</h3>
            <p class="text-xs text-slate-400">Scenario: {{ scenario() }}</p>
        </div>
    </div>
    <ul class="text-xs text-slate-500 space-y-1 list-disc list-inside mb-6 flex-grow">
        @for(step of steps(); track step) {
            <li>{{ step }}</li>
        }
    </ul>
    <button (click)="runTest.emit()" [disabled]="isRunning()" 
            [class]="'w-full py-3 text-white rounded-lg font-bold shadow-lg transition-all flex justify-center items-center gap-3 disabled:opacity-50 disabled:cursor-not-allowed ' + styles().btnBg + ' ' + styles().btnHover">
        @if(isRunning()) { 
            <i class="fa-solid fa-circle-notch animate-spin"></i> Running... 
        } @else { 
            <i class="fa-solid fa-play"></i> Verify
        }
    </button>
    
    @if(result(); as res) {
        <div class="mt-4 p-4 rounded-xl border animate-fade-in" 
             [class.bg-green-900_20]="res.status === 'PASS'" 
             [class.border-green-500_50]="res.status === 'PASS'"
             [class.bg-yellow-900_20]="res.status === 'WARNING' || res.status === 'MOCK'" 
             [class.border-yellow-500_50]="res.status === 'WARNING' || res.status === 'MOCK'"
             [class.bg-red-900_20]="res.status === 'FAIL' || res.status === 'ERROR'" 
             [class.border-red-500_50]="res.status === 'FAIL' || res.status === 'ERROR'">
            <div class="flex items-center gap-2 mb-2">
                <i class="fa-solid" [class]="res.status === 'PASS' ? 'fa-check-circle text-green-500' : ((res.status === 'MOCK' || res.status === 'WARNING') ? 'fa-triangle-exclamation text-yellow-500' : 'fa-xmark-circle text-red-500')"></i>
                <span class="font-bold text-sm" [class]="res.status === 'PASS' ? 'text-green-400' : ((res.status === 'MOCK' || res.status === 'WARNING') ? 'text-yellow-400' : 'text-red-400')">{{ res.status }}</span>
            </div>
            @if (res.message) {
                <p class="text-xs text-slate-400 mb-2">{{ res.message }}</p>
            }
            <div class="font-mono text-xs bg-slate-950 p-2 rounded text-slate-300 overflow-x-auto custom-scrollbar">
                <pre>{{ res | json }}</pre>
            </div>
        </div>
    }
</div>
